module.exports = __webpack_public_path__ + "static/media/marmalade-nyd-logo.2947b47b.svg";